import React from 'react';
import exact from 'prop-types-exact';
import styles from './UpsellClinic.scss';

const UpsellClinicBase = () => {
  return (
    <div className={styles.page_container}>
      <iframe
        className={styles.page_iframe}
        src={`https://pixel-perfect-mirror-azizkad.replit.app/?prefilled_email=${
          JSON.parse(sessionStorage.userInfo).email
        }`}
        title="upsale_iframe"
      />
    </div>
  );
};

UpsellClinicBase.propTypes = exact({});

export const UpsellClinic = React.memo(UpsellClinicBase);
UpsellClinic.displayName = 'UpsellClinic';
